import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useQueryClient } from '@tanstack/react-query';
import { useFetchCountries } from './useFetchCountries';

export const useHomeCountrySelection = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const queryClient = useQueryClient();

  const {
    data: countryList,
    isLoading: isCountriesLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useFetchCountries({
    pageSize: 100,
    search: searchValue,
  });

  const refreshCountryList = () => {
    queryClient.removeQueries({ queryKey: ['countries'] });
    return refetch();
  };

  const { ref, inView } = useInView({
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && countryList?.length > 0) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage, countryList]);

  return {
    countryList,
    isCountriesLoading,
    isFetching,
    searchValue,
    setSearchValue,
    paginationRef: ref,
    hasNextPage,
    refreshCountryList,
  };
};
